import styled from 'styled-components';

export const IconFieldWrapper = styled.div<{ $selected?: boolean }>`
  display: flex;
  color: ${({ theme, $selected }) => ($selected ? theme.baseBlue.a10 : theme.baseBlue.a6)};
`;

export const HoverText = styled.span.attrs({ className: 'caption_text' })``;

export const FieldContainer = styled.div`
  flex-grow: 1;
  margin-left: 10px;
  max-width: 100%;
`;

export const IconContainer = styled.div<{ $clickable: boolean }>`
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'auto')};
  display: flex;
  align-items: center;
  height: 60px;
`;
